module.exports = __webpack_public_path__ + "static/img/948_phase_function_Paper_PointsHejduk_Prediction.012be45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/948_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 4nsQ
// module chunks = 0